import * as types from './mutation-types'

export default {
  [types.ADD_MEASURES](state, data) {
    state.measures = data
  },
  [types.ADD_MEASURE] (state, data) {
    state.measures.push(data)
  },
}
